import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const filterWidth = 370;
const drawerWidth = 250;
const closedDrawerWidth = 70;

export const contentWrapperStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            marginTop: "60px",
        },

        dis: {
            position: "absolute",
            width: "100%",
            height: "1700px",
            backgroundColor: "rgba(82, 82, 82, 0.6)",
            zIndex: theme.zIndex.appBar - 1,
        },

        root: {
            display: "flex",
        },

        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },

        tableContainer: {
            marginTop: "50px",
        },

        mapContainer: {
            marginTop: 50,
        },

        // TODO: figure out why class priority is different in the production build and find a good fix for it
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: `${theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            })} !important`,
            background: `${theme.palette.background.default} !important`,
            width: `calc(100% - ${closedDrawerWidth}px) !important`,
            boxShadow: "inset 0px -1px 0px #E2E2EA !important",
        },

        appSecondBarShift: {
            marginLeft: filterWidth,
            width: `calc(100% - ${filterWidth}px) !important`,
            transition: `${theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            })} !important`,
        },

        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px) !important`,
            transition: `${theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            })} !important`,
        },

        indicatorContainer: {
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
    })
);
